import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function Pricing() {
  const plans = [
    {
      name: 'Starter',
      price: '$99',
      period: '/month',
      description: 'Perfect for small businesses',
      features: [
        '1,000 leads',
        '5,000 customer notifications/month',
        'Basic CRM features',
        'Email support',
        'A2P 10DLC included'
      ]
    },
    {
      name: 'Professional',
      price: '$299',
      period: '/month',
      description: 'For growing businesses',
      features: [
        '10,000 leads',
        '25,000 customer notifications/month',
        'Advanced CRM features',
        'Priority support',
        'A2P 10DLC included',
        'API access',
        'Custom reports'
      ],
      popular: true
    },
    {
      name: 'Enterprise',
      price: 'Custom',
      period: '',
      description: 'For large organizations',
      features: [
        'Unlimited leads',
        'Unlimited notifications',
        'Full CRM suite',
        '24/7 phone support',
        'Dedicated account manager',
        'Custom integrations',
        'SLA guarantee'
      ]
    }
  ];

  return (
    <>
      <Helmet>
        <title>Pricing - Aramco Leads Pro</title>
        <meta name="description" content="Transparent pricing for Aramco Leads Pro CRM platform. Plans starting at $99/month with A2P 10DLC included." />
      </Helmet>

      <div style={{ background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)', color: 'white', padding: '4rem 2rem', textAlign: 'center' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '800', marginBottom: '1rem' }}>Simple Pricing</h1>
          <p style={{ fontSize: '1.25rem', opacity: 0.95 }}>Choose the plan that fits your business</p>
        </div>
      </div>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '4rem 2rem' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', marginBottom: '4rem' }}>
          {plans.map((plan, idx) => (
            <div key={idx} style={{
              background: 'white',
              border: plan.popular ? '2px solid #1e40af' : '1px solid #e5e7eb',
              borderRadius: '12px',
              padding: '2rem',
              position: 'relative',
              transform: plan.popular ? 'scale(1.05)' : 'scale(1)'
            }}>
              {plan.popular && (
                <div style={{
                  position: 'absolute',
                  top: '-12px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  background: '#1e40af',
                  color: 'white',
                  padding: '0.25rem 1rem',
                  borderRadius: '20px',
                  fontSize: '0.875rem',
                  fontWeight: '600'
                }}>
                  Most Popular
                </div>
              )}
              
              <h3 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1f2937', marginBottom: '0.5rem' }}>
                {plan.name}
              </h3>
              <p style={{ color: '#6b7280', marginBottom: '1.5rem' }}>{plan.description}</p>
              
              <div style={{ marginBottom: '1.5rem' }}>
                <span style={{ fontSize: '3rem', fontWeight: '800', color: '#1e40af' }}>{plan.price}</span>
                <span style={{ fontSize: '1.1rem', color: '#6b7280' }}>{plan.period}</span>
              </div>

              <ul style={{ listStyle: 'none', padding: 0, marginBottom: '2rem' }}>
                {plan.features.map((feature, fidx) => (
                  <li key={fidx} style={{
                    color: '#4b5563',
                    marginBottom: '0.75rem',
                    paddingLeft: '1.5rem',
                    position: 'relative'
                  }}>
                    <span style={{ position: 'absolute', left: 0, color: '#1e40af', fontWeight: '600' }}>✓</span>
                    {feature}
                  </li>
                ))}
              </ul>

              <Link to="/contact" style={{
                display: 'block',
                background: plan.popular ? '#1e40af' : '#f3f4f6',
                color: plan.popular ? 'white' : '#1e40af',
                padding: '1rem',
                borderRadius: '8px',
                textAlign: 'center',
                textDecoration: 'none',
                fontWeight: '600'
              }}>
                Get Started
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
